import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import * as AOS from 'aos';
import { from } from 'rxjs';
import { LinkService } from '../../../_services/langhfre.service';
import { Router } from '@angular/router';
import { LoadScriptService } from 'src/app/_services/load-script.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-technology-platforms',
  templateUrl: './technology-platforms.component.html',
  styleUrls: ['./technology-platforms.component.scss']
})
export class TechnologyPlatformsComponent implements OnInit {

  country: string;
  email: any;
  // emailEnterprise : FormGroup;
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private router: Router,
    public loadScript: LoadScriptService
  ) {
    
  }

  ngOnInit() {
    this.titleService.setTitle("트링카 엔터프라이즈 | 기술 플랫폼");
    this.metaTagService.updateTag({ name: 'description', content: "트링카를 사용하면 애플리케이션 내에서 실시간 글쓰기 지원을 쉽게 추가할 수 있습니다. 트링카의 글쓰기 제안을 제공하여 고유한 솔루션을 구축해 보세요." });
    this.metaTagService.updateTag({ property: 'og:title', content: "트링카 엔터프라이즈 | 기술 플랫폼" });
    this.metaTagService.updateTag({ property: 'og:description', content: "트링카를 사용하면 애플리케이션 내에서 실시간 글쓰기 지원을 쉽게 추가할 수 있습니다. 트링카의 글쓰기 제안을 제공하여 고유한 솔루션을 구축해 보세요." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/enterprise/technology-platforms' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/technologyPlatform.png' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '트링카 엔터프라이즈 | 기술 플랫폼' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "트링카를 사용하면 애플리케이션 내에서 실시간 글쓰기 지원을 쉽게 추가할 수 있습니다. 트링카의 글쓰기 제안을 제공하여 고유한 솔루션을 구축해 보세요." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/technologyPlatform.png' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/enterprise/technology-platforms' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/enterprise/technology-platforms' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/enterprise/technology-platforms' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/enterprise/technology-platforms' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/enterprise/technology-platforms' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/enterprise/technology-platforms' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/enterprise/technology-platforms' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/enterprise/technology-platforms' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/enterprise/technology-platforms' });
    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      // document.getElementById('main_header').classList.add('homepageHeader');
      $.getScript('../../../../assets/js/hubslider.js', function () { });
      $.getScript('../../../../assets/js/owl.carousel.min.js', function () { });
      $.getScript('../../../../assets/js/wisepop.js', function () { });
      $.getScript('../../../../assets/js/home_client_slider.js', function () { });
      AOS.init();
    }
  }
  
}
